/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FORM1,
  FORM2,
  FORM3,
  FORM4,
  FORM5,
} from 'utils/__consts/MyDemands/DemandForms'
import {
  DemandTranscoECE,
  MotifTransco,
} from 'utils/__interfaces/MyDemands/DemandEntity'
import {
  Category,
  MyDemandsFields,
} from 'utils/__interfaces/MyDemands/myDemands'

export const getCategories = (
  listTransco: DemandTranscoECE[],
  isSupport = false
) => {
  const categoriesWithoutDuplicates = new Map(
    listTransco
      .filter((item) =>
        item.demandCategoryECE.value === 'SUPPORT_TECHNIQUE' ? isSupport : true
      )
      .map((item) => [item.demandCategoryECE.id, item.demandCategoryECE])
  ).values()

  return [...categoriesWithoutDuplicates].sort(
    (a, b) => a.displayOrder - b.displayOrder
  )
}

export const getMotifsByCategory = (
  listTransco: DemandTranscoECE[],
  selectedCategory: Category
) => {
  return listTransco
    .filter(
      (item) =>
        item.defaultValue && item.demandCategoryECE.id === selectedCategory.id
    )
    .map((item) => item.demandMotifECE)
    .sort((a, b) => a.displayOrder - b.displayOrder)
}

export const getTranscoMotifs = (listTransco: DemandTranscoECE[]) => {
  return listTransco.map((item) => {
    return {
      id: item.demandMotifECE.id,
      motifECE: item.demandMotifECE.label,
      motifCodeECE: item.demandMotifECE.value,
      type: item.typeDemand,
      motif: item.motifDemand,
      detail: item.detailDemand,
    }
  })
}

export const groupMotifsByCategories = (listTransco: DemandTranscoECE[]) => {
  return listTransco
    .filter((item) => item.defaultValue)
    .sort(
      (a, b) =>
        a.demandCategoryECE.displayOrder - b.demandCategoryECE.displayOrder ||
        a.demandMotifECE.displayOrder - b.demandMotifECE.displayOrder
    )
    .reduce((acc: any, item) => {
      const category = item.demandCategoryECE.label
      const motif = {
        value: item.demandMotifECE.id,
        label: item.demandMotifECE.label,
      }
      const count = getMotifsByCategory(listTransco, item.demandCategoryECE)
        .length
      const key = `${category} (${count})`

      const categoryIndex = acc.findIndex((group: any) => group.label === key)
      if (categoryIndex >= 0) {
        acc[categoryIndex].options.push(motif)
      } else {
        acc.push({
          label: key,
          options: [motif],
        })
      }

      return acc
    }, [])
}

export const convertMotifFromEceToCcap = (
  listTransco: MotifTransco[],
  motifsIds: string[]
) => {
  return listTransco
    .filter((item) => motifsIds.some((idItem) => idItem === item.id))
    .map((item) => `${item.type};${item.motif};${item.detail}`)
}

export const getFormByMotif = (formNumber: number) => {
  const FORMS: { [key: number]: MyDemandsFields[] } = {
    // 0: FORM_DEVIS, Le numéro 0 sera réservé au nouveau formulaire de devis
    1: FORM1,
    2: FORM2,
    3: FORM3,
    4: FORM4,
    5: FORM5,
  }
  return FORMS[formNumber]
}
